const systemdataRoutes = [
  {
    path: '/System/Role',
    name: 'System_Role',
    component: () => import('@/pages/system/role'),
    meta: {keepAlive: true, name: '角色管理'},
  },
  {
    path: '/System/Dictionary',
    name: 'System_Dictionary',
    component: () => import('@/pages/system/dictionary'),
    meta: {keepAlive: true, name: '数字字典'},
  },
  {
    path: '/System/Power',
    name: 'System_Power',
    component: () => import('@/pages/system/power'),
    meta: {keepAlive: true, name: '权限管理'},
  },
  {
    path: '/System/Page',
    name: 'System_Page',
    component: () => import('@/pages/system/page'),
    meta: {keepAlive: true, name: '权限管理'},
  },
]

export default systemdataRoutes



// WEBPACK FOOTER //
// ./src/router/modules/systemdata.js